import Vue from "vue";
export const defaultConfig = {
  //bottoni canvas
  button_storeLocator: true,
  button_favorite: true,
  button_print: true,
  button_share: false,
  //colori testo e icone
  icon_color: "#EF7C00",
  btn_menu_color: "pink",
  logoImage: "https://storage.googleapis.com/bucket_for_exchange/custom-configurator/logos/logo-default.png",
  logoByUser: false,
  //controlli filtri etc false per non vederli
  btn_ritornaHome: true,
  btn_darkMode: true,
  frontali_marchio: true,
  frontali_search: true,
  frontali_tipologia: true,
  frontali_asianFitting: false,
  frontali_order: "",
  frontali_dynamic_filter_enabled: false,
  frontali_dynamic_filter_label: "",
  frontali_dynamic_filter_field: "",
  frontali_dynamic_filter_options: [],
  colori_categories: true,
  colori_finiture: true,
  colori_finiture_codes: ["NESSUNO", "M", "S", "N"],
  colori_tinta_unita: true,
  colori_search: true,
  aste_misure: true,
  aste_material: true,
  aste_material_codes: ["PL", "MT"],
  aste_finiture: true,
  aste_finiture_mode: 'manual',
  aste_finiture_frontale_filter_enabled: true,
  aste_finiture_codes: ["NESSUNO", "N", "M", "S"],
  aste_finiture_list: [],
  aste_metalColor: true,
  aste_metalColor_codes: ["GUN", "GOLD"],
  personalizzazioniAste: true,
  nome_ciliare: true,
  nome_extdx: true,
  nome_extsx: true,
  nome_intdx: true,
  nome_intsx: true,
  lenti_stile: true,
  //controlli display modo in cui si vedono le griglie degli item
  //wrap false = carousel
  //wrap true = griglia e scroll in basso
  frontali_wrap: false,
  colori_wrap: true,
  aste_wrap: true,
  lentiSole_wrap: false,
  menu_frontali: true,
  menu_colori: true,
  menu_aste: true,
  menu_nome: true,
  menu_clip: true,
  menu_lenti: true,
  site_id: "",
  config_database: "",
  defaultFrontModel: "",
  defaultFrontColor: "EP0001",
  defaultTemplesColor: "EP0001",
  frontali_default_color_enabled: true,
  aste_default_color_enabled: true,
  login_required: false,
  esclusivaCheck: false,
  esclusiva: ""
};
const configState = Vue.observable({
  ...defaultConfig
});
export function setCustomConfig(partialConfig) {
  Object.assign(configState, partialConfig);
}
export function replaceCustomConfig(newConfig) {
  Object.assign(configState, newConfig);
}
export default configState;